export const csvEscape = (v) => {
  if (v == null) return "";
  const s = String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const toCSV = (rows) => rows.map((r) => r.map(csvEscape).join(",")).join("\n");

export const fmt = (value, decimals = 1) => {
  if (!Number.isFinite(value)) return "";
  return Number(value.toFixed(decimals));
};

export const pct = (value) => (Number.isFinite(value) ? `${fmt(value, 1)}%` : "");

export function sanitizeExportSheetName(prefix, index) {
  const safe = String(prefix || "sheet")
    .replace(/[\\/?*[\]:]/g, "_")
    .replace(/\s+/g, "_");
  return `Q${String(index + 1).padStart(2, "0")}_${safe}`.slice(0, 31);
}
